module.exports = __webpack_public_path__ + "img/arrow.7f89c78c.svg";